export class ReliabilityFailOnFitUpdateModel {
  public Id?: number;
  public RequestOrderId?: number;
  public RequestType?: number;
  public ReportId?: number;
  public BeforePoolOrderType?: string;
  public BeforePoolOrderNumber?: number;
  public BeforePoolOrderStatus?: string;
  public BeforePoolVendorType?: string;
  public BeforePoolVendor?: string;
  public BeforePoolCondition?: string;
  public AfterPoolOrderType?: string;
  public AfterPoolOrderNumber?: number;
  public AfterPoolOrderStatus?: string;
  public AfterPoolVendorType?: string;
  public AfterPoolVendor?: string;
  public AfterPoolCondition?: string;
  public FofStatus?: number;
  public Reason?: number;
  public OtherReason?: string;
}
